import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectBank',
  props: {
    link: {},
    isConnected: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const openLink = () => {
        window.open(props.link, '_blank');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost_primary",
    size: "xs",
    width: "narrow",
    onClick: openLink
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('viia.attach_bank')) + " ", 1),
      _createVNode(_unref(ChevronRight), { class: "text-primary" })
    ]),
    _: 1
  }))
}
}

})